export default {
  path: '/',
  component: () => import('@/layouts/LayoutContentAppNav.vue'),
  meta: { protected: true },
  children: [
    {
      path: '/early-admission/setup',
      name: 'ProvisionalAdmissionWizard',
      component: () => import('@/views/early-admission/ProvisionalAdmissionWizard.vue'),
    },
    {
      path: '/early-admission/enroll',
      name: 'EarlyAdmissionForm',
      component: () => import('@/views/early-admission/EarlyAdmissionForm.vue'),
    },
    {
      path: '/early-admission/assign-roll-numbers',
      name: 'RollNumberAssignment',
      component: () => import('@/views/early-admission/RollNumberAssignment.vue'),
    },
    {
      path: '/early-admission/collect-fee',
      name: 'CollectEarlyAdmissionFee',
      component: () => import('@/views/early-admission/CollectEarlyAdmissionFee.vue'),
    },
    {
      path: '/early-admission/assign-fees-to-student',
      name: 'AssignFeesToStudentEarlyAdmission',
      component: () => import('@/views/early-admission/AssignFeesToStudent.vue'),
    },
  ],
}
